
import {
  Summon, 
  Creature, 
  Transform
} from "@dndModels";

/**
 * This is a helper to summon controls.  
 * It holds specific creatures, or a SummonStatBlock, 
 * along with how many will be summoned.
 */
export class SummonOption2 {
  custom_stat_block: Summon | null = null;
  creature: Creature | null = null;
  transform: Transform | null = null;
  count = 0;
  description = "";

  get challenge_rating() {
    if (this.creature) {
      return this.creature.challenge_rating;
    } 
    return 0;
  }

  get _id() {
    if (this.creature) {
      return this.creature._id;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.true_id;
    }
    return "";
  }

  get creature_type() {
    if (this.creature) {
      return this.creature.creature_type;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.creature_type;
    }
    return "";
  }

  get subtypes() {
    if (this.creature) {
      return this.creature.subtypes;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.subtypes;
    }
    return [];
  }

  get name() {
    if (this.creature) {
      return this.creature.name;
    } else if (this.custom_stat_block) {
      return this.custom_stat_block.name;
    }
    return "";
  }
}